 
import { AsyncPipe } from '@angular/common';
import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Header } from './shared/layouts/header/header';
import { SharedModule } from './shared/shared-module';
import { HeaderService } from './shared/services/headerService';
import { Themecolors } from './shared/services/themecolors';
import { GlobalLoaderComponent } from './shared/components/global-loader/global-loader';
import { ShareViaEmailModalComponent } from './shared/components/share-via-email-modal/share-via-email-modal';
import { ToasterComponent } from './shared/components/toaster/toaster';
 
//import { Switches } from './shared/components/switches/switches';




@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    AsyncPipe,
    RouterModule,
    Header,
    SharedModule,
    GlobalLoaderComponent,
    ShareViaEmailModalComponent,
    ToasterComponent,
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  protected title = 'Referral Portal';
  protected readonly headerVisible$ = inject(HeaderService).getHeader();
  localtheme: any;
  themes: string[] = [];

  private readonly switchservice = inject(Themecolors);

  switchClick(theme: string): void {
    this.switchservice.setTheme(theme);
  }
}